import React from 'react';


export const ArrowIcon = () => (
  <svg
    className="arrow-icon"
    width="13"
    height="7"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.499978 1.24994C0.499217 1.11833 0.524442 0.98787 0.574206 0.866033C0.623971 0.744195 0.697298 0.633379 0.789979 0.539939C0.882942 0.446211 0.993542 0.371816 1.1154 0.321048C1.23726 0.270279 1.36797 0.244141 1.49998 0.244141C1.63199 0.244141 1.7627 0.270279 1.88455 0.321048C2.00641 0.371816 2.11701 0.446211 2.20998 0.539939L6.99998 5.33994L11.79 0.539939C11.9836 0.351635 12.2441 0.247954 12.5141 0.251705C12.7842 0.255456 13.0417 0.366331 13.23 0.559939C13.4183 0.753547 13.522 1.01403 13.5182 1.28408C13.5145 1.55413 13.4036 1.81164 13.21 1.99994L7.70998 7.49994C7.61702 7.59367 7.50641 7.66806 7.38456 7.71883C7.2627 7.7696 7.13199 7.79574 6.99998 7.79574C6.86797 7.79574 6.73726 7.7696 6.6154 7.71883C6.49354 7.66806 6.38294 7.59367 6.28998 7.49994L0.789979 1.99994C0.692368 1.9018 0.616191 1.78447 0.566272 1.65537C0.516353 1.52627 0.493779 1.38821 0.499978 1.24994Z"
      fill=""
    ></path>
  </svg>
);

export default ArrowIcon;
